import AuthAxios from '@/lib/api/axios/AuthAxios'
import { ENDPOINT_BASE } from '@/config/endpoints'

const remindersEndpoint = (workspaceId: string) =>
  `${ENDPOINT_BASE}/e/${workspaceId}/reminders`

export interface ReminderMigrationStatus {
  hasNonAppReminders: boolean
}

/**
 * Returns true when the user has at least one active reminder with the
 * deprecated NotificationChannel != 'app'. The Notifications settings page
 * uses this to decide whether to render the reminder-channel migration banner.
 *
 * The actual banner show/hide also factors in whether the user has dismissed
 * the `reminder_channel_migration` notice (stored in NotificationsJson via
 * NotificationPreferences.dismissedNotices).
 */
export const getReminderMigrationStatus = async (
  workspaceId: string,
): Promise<ReminderMigrationStatus> => {
  const response = await AuthAxios.get<ReminderMigrationStatus>(
    `${remindersEndpoint(workspaceId)}/migration-status`,
  )
  return response.data
}
